import React from 'react';
//import Claim from '../components/Profile/Claim';
import { injectIntl } from 'react-intl';
import { compose, lifecycle} from 'recompose';
import { connect } from 'react-redux';
import { getIsLogged } from '../selectors/user';
import page from 'page';
import Claim from '../components/Profile/Claim1';

//компонент страницы Стать участником
const Persons = ({role}) => {
    return (
        <div className='Become-member'>
            <Claim lightVersion={true}/>
        </div> 
    )
}

const mapStateToProps = state => ({
    isLogged: getIsLogged(state),
})

export default injectIntl(compose(
    connect(mapStateToProps),
    lifecycle({
        componentWillReceiveProps (np) {
            //чтобы точно не попасть на эту страницу в роли персоны
            if (this.props.isLogged && !np.isLogged) page('/')
        }
    })
)(Persons))


// WEBPACK FOOTER //
// ./src/containers/Persons.jsx